import { Component } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { DelegatedLabeledComponent } from '../delegated-labeled.component';

@Component({
  selector: 'subs-currency-static-text',
  template: `
    <clr-input-container>
      <label class="clr-col-12 clr-col-md-auto" [style]="safeLabelStyle">{{
        label
      }}</label>
      <input
        clrInput
        class="clr-col-12 clr-col-md"
        [style]="safeInputStyle"
        [attr.data-test-id]="controlName"
        [name]="controlName"
        [formControlName]="controlName"
        readonly="true"
        currencyMask
      />
    </clr-input-container>
  `,
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class CurrencyStaticTextComponent extends DelegatedLabeledComponent {
  constructor(sanitizer: DomSanitizer) {
    super(sanitizer);
  }
}
